/**
 * AUTO-GENERATED by scripts/build-model-inventory.js — do not edit by hand.
 * 123 live models across 25 providers.
 * Source: backend/scripts/seed/seed_models.json
 * Regenerate: npm run build:models
 */

/** Every live model, grouped by the company that trained it. */
export const MODEL_PROVIDERS = [
  {
    "provider": "OpenAI",
    "models": [
      {
        "name": "GPT 5.1",
        "modality": "Text"
      },
      {
        "name": "GPT Image 1 Mini",
        "modality": "Image"
      },
      {
        "name": "GPT Image 2",
        "modality": "Image"
      },
      {
        "name": "GPT Image 2.5 Flare",
        "modality": "Image"
      },
      {
        "name": "GPT Image 2.5 Sunburst",
        "modality": "Image"
      },
      {
        "name": "GPT-4o mini Transcribe",
        "modality": "Text"
      },
      {
        "name": "GPT-4o mini TTS",
        "modality": "Audio"
      },
      {
        "name": "GPT-4o Transcribe",
        "modality": "Text"
      },
      {
        "name": "GPT-5.3 Codex",
        "modality": "Text"
      },
      {
        "name": "GPT-5.4",
        "modality": "Text"
      },
      {
        "name": "GPT-5.5",
        "modality": "Text"
      },
      {
        "name": "GPT-5.6 Sol",
        "modality": "Text"
      },
      {
        "name": "GPT-5.6 Sol Pro",
        "modality": "Text"
      },
      {
        "name": "GPT-5.6 Terra",
        "modality": "Text"
      },
      {
        "name": "GPT-5.6 Terra Pro",
        "modality": "Text"
      },
      {
        "name": "GPT-6 Astra",
        "modality": "Text"
      },
      {
        "name": "o3",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Alibaba",
    "models": [
      {
        "name": "Happy Horse 1.0 (Image to Video)",
        "modality": "Video"
      },
      {
        "name": "Happy Horse 1.0 (Text to Video)",
        "modality": "Video"
      },
      {
        "name": "Qwen 3.5 397B",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.5 397B Thinking",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.7 Flash",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.7 Max",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.7 Plus",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.8 Flash",
        "modality": "Text"
      },
      {
        "name": "Qwen 3.8 Max",
        "modality": "Text"
      },
      {
        "name": "Qwen Audio 3.0 TTS Flash",
        "modality": "Audio"
      },
      {
        "name": "Qwen Image",
        "modality": "Image"
      },
      {
        "name": "Qwen Image 2",
        "modality": "Image"
      },
      {
        "name": "Qwen Image 3 Pro",
        "modality": "Image"
      },
      {
        "name": "Wan 2.5",
        "modality": "Video"
      },
      {
        "name": "Wan 2.7 Image",
        "modality": "Image"
      },
      {
        "name": "Wan 2.7 Img2Vid",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "Google",
    "models": [
      {
        "name": "Gemini 3.1 Flash Lite",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.1 Pro",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.5 Flash",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.5 Flash Lite",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.6 Flash",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.7 Flash",
        "modality": "Text"
      },
      {
        "name": "Gemini 3.8 Flash",
        "modality": "Text"
      },
      {
        "name": "Gemma 4 26B A4B",
        "modality": "Text"
      },
      {
        "name": "Nano Banana 2",
        "modality": "Image"
      },
      {
        "name": "Veo 3.1",
        "modality": "Video"
      },
      {
        "name": "Veo 3.1 Fast",
        "modality": "Video"
      },
      {
        "name": "Veo 3.1 Img2Vid",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "MiniMax",
    "models": [
      {
        "name": "Hailuo 2.3",
        "modality": "Video"
      },
      {
        "name": "Hailuo 2.3 Img2Vid",
        "modality": "Video"
      },
      {
        "name": "Hailuo 2.3 Pro",
        "modality": "Video"
      },
      {
        "name": "Hailuo 2.3 Pro Img2Vid",
        "modality": "Video"
      },
      {
        "name": "Hailuo 3",
        "modality": "Video"
      },
      {
        "name": "MiniMax H3 Max",
        "modality": "Video"
      },
      {
        "name": "MiniMax M2.5",
        "modality": "Text"
      },
      {
        "name": "MiniMax M2.7",
        "modality": "Text"
      },
      {
        "name": "MiniMax M3",
        "modality": "Text"
      },
      {
        "name": "MiniMax Music 2.0",
        "modality": "Audio"
      },
      {
        "name": "MiniMax Music 2.6",
        "modality": "Audio"
      },
      {
        "name": "MiniMax Music 3",
        "modality": "Audio"
      }
    ]
  },
  {
    "provider": "Anthropic",
    "models": [
      {
        "name": "Claude Haiku 4.5",
        "modality": "Text"
      },
      {
        "name": "Claude Opus 5",
        "modality": "Text"
      },
      {
        "name": "Claude Sonnet 4.5",
        "modality": "Text"
      },
      {
        "name": "Claude Sonnet 4.6",
        "modality": "Text"
      },
      {
        "name": "Claude Sonnet 5",
        "modality": "Text"
      },
      {
        "name": "Fable 5",
        "modality": "Text"
      },
      {
        "name": "Fable 5.1",
        "modality": "Text"
      },
      {
        "name": "Opus 4.6",
        "modality": "Text"
      },
      {
        "name": "Opus 4.7",
        "modality": "Text"
      },
      {
        "name": "Opus 4.8",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Kling",
    "models": [
      {
        "name": "Kling 2.5 Turbo Pro",
        "modality": "Video"
      },
      {
        "name": "Kling 2.5 Turbo Pro Img2Vid",
        "modality": "Video"
      },
      {
        "name": "Kling 3 Pro",
        "modality": "Video"
      },
      {
        "name": "Kling 3.0 Img2Vid",
        "modality": "Video"
      },
      {
        "name": "Kling Avatar v2 Pro",
        "modality": "Video"
      },
      {
        "name": "Kling Avatar v2 Standard",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "ByteDance",
    "models": [
      {
        "name": "Seedance 2.0",
        "modality": "Video"
      },
      {
        "name": "Seedance 2.0 Img2Vid",
        "modality": "Video"
      },
      {
        "name": "Seedream 4.0",
        "modality": "Image"
      },
      {
        "name": "Seedream 4.5",
        "modality": "Image"
      },
      {
        "name": "Wan 2.7 Text to Video",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "Fal AI",
    "models": [
      {
        "name": "AuraSR",
        "modality": "Image"
      },
      {
        "name": "Image2SVG",
        "modality": "Image"
      },
      {
        "name": "MultiTalk Avatar",
        "modality": "Video"
      },
      {
        "name": "MultiTalk Avatar (TTS)",
        "modality": "Video"
      },
      {
        "name": "SeedVR2 Image Upscaler",
        "modality": "Image"
      }
    ]
  },
  {
    "provider": "Tencent",
    "models": [
      {
        "name": "Hunyuan 3D v3.1 Pro",
        "modality": "3D"
      },
      {
        "name": "Hunyuan 3D v3.1 Pro (Image)",
        "modality": "3D"
      },
      {
        "name": "Hunyuan 3D v3.1 Rapid",
        "modality": "3D"
      },
      {
        "name": "Hunyuan 3D v3.1 Rapid (Image)",
        "modality": "3D"
      },
      {
        "name": "Hunyuan Avatar",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "DeepSeek",
    "models": [
      {
        "name": "DeepSeek V4 Flash",
        "modality": "Text"
      },
      {
        "name": "DeepSeek V4 Flash 0731",
        "modality": "Text"
      },
      {
        "name": "DeepSeek V4 Pro",
        "modality": "Text"
      },
      {
        "name": "DeepSeek V4 Pro 0813",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "ElevenLabs",
    "models": [
      {
        "name": "ElevenLabs Eleven v3 TTS",
        "modality": "Audio"
      },
      {
        "name": "ElevenLabs Scribe V1",
        "modality": "Text"
      },
      {
        "name": "ElevenLabs Scribe V2",
        "modality": "Text"
      },
      {
        "name": "ElevenLabs Sound Effects V2",
        "modality": "Audio"
      }
    ]
  },
  {
    "provider": "Meshy",
    "models": [
      {
        "name": "Meshy v6",
        "modality": "3D"
      },
      {
        "name": "Meshy v6 (Image)",
        "modality": "3D"
      },
      {
        "name": "Meshy v6 Preview",
        "modality": "3D"
      },
      {
        "name": "Meshy v6 Preview (Image)",
        "modality": "3D"
      }
    ]
  },
  {
    "provider": "Z.ai",
    "models": [
      {
        "name": "GLM 5.1",
        "modality": "Text"
      },
      {
        "name": "GLM 5.2",
        "modality": "Text"
      },
      {
        "name": "GLM 5.3",
        "modality": "Text"
      },
      {
        "name": "GLM 5.3 Flash",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Ideogram",
    "models": [
      {
        "name": "Ideogram Remove Background",
        "modality": "Image"
      },
      {
        "name": "Ideogram Upscale",
        "modality": "Image"
      },
      {
        "name": "Ideogram V4 Fast",
        "modality": "Image"
      }
    ]
  },
  {
    "provider": "Black Forest Labs",
    "models": [
      {
        "name": "FLUX.2 Pro",
        "modality": "Image"
      },
      {
        "name": "FLUX.3 Video",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "Gab AI",
    "models": [
      {
        "name": "Arya",
        "modality": "Text"
      },
      {
        "name": "Image Generator",
        "modality": "Image"
      }
    ]
  },
  {
    "provider": "HeyGen",
    "models": [
      {
        "name": "HeyGen Avatar 4",
        "modality": "Video"
      },
      {
        "name": "HeyGen Video Agent",
        "modality": "Video"
      }
    ]
  },
  {
    "provider": "Moonshot",
    "models": [
      {
        "name": "Kimi K2.6",
        "modality": "Text"
      },
      {
        "name": "Kimi K3",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Recraft",
    "models": [
      {
        "name": "Recraft V4.1 Text to Vector",
        "modality": "Image"
      },
      {
        "name": "Recraft Vectorize",
        "modality": "Image"
      }
    ]
  },
  {
    "provider": "CassetteAI",
    "models": [
      {
        "name": "CassetteAI Sound Effects",
        "modality": "Audio"
      }
    ]
  },
  {
    "provider": "Meta",
    "models": [
      {
        "name": "Muse Spark 1.2",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Nous Research",
    "models": [
      {
        "name": "Hermes 4 405B",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "NVIDIA",
    "models": [
      {
        "name": "Wizper (Whisper v3)",
        "modality": "Text"
      }
    ]
  },
  {
    "provider": "Topaz Labs",
    "models": [
      {
        "name": "Topaz Image Upscaler",
        "modality": "Image"
      }
    ]
  },
  {
    "provider": "Tripo3D",
    "models": [
      {
        "name": "Tripo H3.1",
        "modality": "3D"
      }
    ]
  }
];

export const MODEL_TOTAL = 123;
export const PROVIDER_TOTAL = 25;

/** Live model count per headline medium. */
export const MODALITY_COUNTS = {
  "3D": 9,
  "Video": 28,
  "Image": 22,
  "Audio": 8,
  "Text": 56
};

/** Representative credit prices, read from each model's configured base cost. */
export const CREDIT_EXAMPLES = [
  {
    "label": "A message to a frontier chat model",
    "model": "Claude Sonnet 5",
    "credits": 8
  },
  {
    "label": "A generated image",
    "model": "Seedream 4.5",
    "credits": 6
  },
  {
    "label": "An original music track",
    "model": "MiniMax Music 2.0",
    "credits": 8
  },
  {
    "label": "A generated video clip",
    "model": "Veo 3.1",
    "credits": 75
  },
  {
    "label": "A textured 3D model",
    "model": "Meshy v6",
    "credits": 220
  }
];
